module.exports = __webpack_public_path__ + "static/media/vfx.24c55b97.gif";